export const translations = {
  en: {
    // Navigation
    backToSurahs: 'Back to Surahs',
    viewBookmarks: 'View Bookmarks',
    home: 'Home',
    bookmarks: 'Bookmarks',
    
    // Hero
    heroTitle: 'The Noble Quran',
    heroSubtitle: 'Read, Listen, and Bookmark the Holy Quran',
    searchPlaceholder: 'Search surah by name or number...',
    
    // Surah Info
    ayahs: 'Ayahs',
    makkah: 'MAKKAH',
    madinah: 'MADINAH',
    
    // Actions
    playFullSurah: 'Play Full Surah',
    translation: 'Translation',
    selectReciter: 'Select Reciter',
    
    // Bookmarks
    bookmarksTitle: 'Bookmarks',
    noBookmarks: 'No bookmarks yet. Start reading and bookmark your favorite verses!',
    bookmarkAdded: 'Bookmark added',
    bookmarkRemoved: 'Bookmark removed',
    
    // Audio
    playingFullSurah: 'Playing full surah',
    continuousPlay: 'Continuous play ON',
    continuousPlayOff: 'Continuous play OFF',
    
    // Menu
    quickNavigation: 'Quick Navigation',
    allSurahs: 'All Surahs',
    juz: 'Juz',
    selectJuz: 'Select Juz',
    
    // Language
    language: 'Language',
    appLanguage: 'App Language',
    
    // Errors
    failedToLoad: 'Failed to load surah',
    failedToLoadBookmarks: 'Failed to load bookmarks',
    failedToDeleteBookmark: 'Failed to delete bookmark'
  },
  fr: {
    // Navigation
    backToSurahs: 'Retour aux Sourates',
    viewBookmarks: 'Voir les Favoris',
    home: 'Accueil',
    bookmarks: 'Favoris',
    
    // Hero
    heroTitle: 'Le Saint Coran',
    heroSubtitle: 'Lire, Écouter et Marquer le Saint Coran',
    searchPlaceholder: 'Rechercher une sourate par nom ou numéro...',
    
    // Surah Info
    ayahs: 'Versets',
    makkah: 'LA MECQUE',
    madinah: 'MÉDINE',
    
    // Actions
    playFullSurah: 'Jouer la Sourate Complète',
    translation: 'Traduction',
    selectReciter: 'Sélectionner le Récitateur',
    
    // Bookmarks
    bookmarksTitle: 'Favoris',
    noBookmarks: 'Aucun favori pour le moment. Commencez à lire et marquez vos versets préférés!',
    bookmarkAdded: 'Favori ajouté',
    bookmarkRemoved: 'Favori supprimé',
    
    // Audio
    playingFullSurah: 'Lecture de la sourate complète',
    continuousPlay: 'Lecture continue ACTIVÉE',
    continuousPlayOff: 'Lecture continue DÉSACTIVÉE',
    
    // Menu
    quickNavigation: 'Navigation Rapide',
    allSurahs: 'Toutes les Sourates',
    juz: 'Juz',
    selectJuz: 'Sélectionner un Juz',
    
    // Language
    language: 'Langue',
    appLanguage: 'Langue de l\'Application',
    
    // Errors
    failedToLoad: 'Échec du chargement de la sourate',
    failedToLoadBookmarks: 'Échec du chargement des favoris',
    failedToDeleteBookmark: 'Échec de la suppression du favori'
  },
  ar: {
    // Navigation
    backToSurahs: 'العودة إلى السور',
    viewBookmarks: 'عرض المفضلة',
    home: 'الرئيسية',
    bookmarks: 'المفضلة',
    
    // Hero
    heroTitle: 'القرآن الكريم',
    heroSubtitle: 'اقرأ واستمع وضع علامة على القرآن الكريم',
    searchPlaceholder: 'ابحث عن سورة بالاسم أو الرقم...',
    
    // Surah Info
    ayahs: 'آيات',
    makkah: 'مكة',
    madinah: 'المدينة',
    
    // Actions
    playFullSurah: 'تشغيل السورة كاملة',
    translation: 'الترجمة',
    selectReciter: 'اختر القارئ',
    
    // Bookmarks
    bookmarksTitle: 'المفضلة',
    noBookmarks: 'لا توجد مفضلة حتى الآن. ابدأ القراءة وضع علامة على آياتك المفضلة!',
    bookmarkAdded: 'تمت إضافة المفضلة',
    bookmarkRemoved: 'تمت إزالة المفضلة',
    
    // Audio
    playingFullSurah: 'تشغيل السورة كاملة',
    continuousPlay: 'التشغيل المستمر مُفعّل',
    continuousPlayOff: 'التشغيل المستمر مُعطّل',
    
    // Menu
    quickNavigation: 'التنقل السريع',
    allSurahs: 'جميع السور',
    juz: 'الجزء',
    selectJuz: 'اختر الجزء',
    
    // Language
    language: 'اللغة',
    appLanguage: 'لغة التطبيق',
    
    // Errors
    failedToLoad: 'فشل تحميل السورة',
    failedToLoadBookmarks: 'فشل تحميل المفضلة',
    failedToDeleteBookmark: 'فشل حذف المفضلة'
  }
};